import { signal } from '@preact/signals';
import type { PlaybackState } from '@fcbh/audio';

export const route = signal<{ book: string; chapter: number }>({ book: 'MAT', chapter: 1 });

export const playback = signal<PlaybackState>({
  playing: false,
  currentSec: 0,
  durationSec: 0,
  rate: 1,
  bufferedSec: 0,
});

